// extracted by mini-css-extract-plugin
export default {"root":"Tc_root__goPcb"};